import { ReactNode }                                from "react";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import CsvImportForm                                from "../../components/customer/import/CsvImportForm";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";
import React                                        from "react";

class CustomerCsvImportContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state: BaseState = {
      menuType: MenuType.SETTING,
      headerTitle: "顧客情報インポート"
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "顧客情報インポート",
                path: "/customer/import"
              }
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>

        <TopSection>
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <TopSection>
          <p>CSV形式のファイルをアップロードすることで、一括で顧客情報を取り込むことができます。</p>
          <p>対応しているCSV形式は<a download="ResKa顧客情報インポート.csv" href="http://cdn.reska.jp/csv/ResKa顧客情報インポート.csv">こちら</a>からダウンロードできます。</p>
        </TopSection>

        <CsvImportForm/>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(CustomerCsvImportContainer);
